import { Box, Tooltip, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import React, { useMemo } from "react";
import { getPermitTypeData } from "../../permitForms/permitFormHelpers";

const PermitPackageIndicators = ({ permitData }) => {
  const { selectedRow, leftValue, selectedPermitType } = useSelector(
    (state) => state.myPermitsComponent
  );

  const currentPermitData = useMemo(
    () => getPermitTypeData(selectedRow, selectedPermitType),
    [selectedRow, selectedPermitType]
  );
  const isMainPermitType = selectedPermitType === selectedRow?.permit_type;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        py: 1,
        px: 1,
        borderBottom: "1px solid #e0e0e0", // Add a subtle divider below
      }}
    >
      {/* Created Status */}
      <Tooltip title="Document Created">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {currentPermitData?.selected_documents?.[leftValue]?.created ? (
            <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
          ) : (
            <CancelIcon color="error" sx={{ fontSize: 30 }} />
          )}
          <Typography variant="caption" color="textSecondary" fontWeight="bold">
            Created
          </Typography>
        </Box>
      </Tooltip>
      {/* Notarized Status */}
      <Tooltip title="Document Notarized">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {
            // Case 1: leftValue === 0 and noc_notarized is true
            (leftValue === 0 &&
              selectedRow?.notarized === true &&
              selectedRow?.noc_created === true &&
              isMainPermitType) ||
            // Case 2: leftValue === 1, noc_notarized is true, and final_documents array includes the selected document's name
            (leftValue === 1 &&
              selectedRow?.notarized === true &&
              selectedRow?.noc_created === true &&
              isMainPermitType &&
              selectedRow?.processing_permit?.notarization?.final_documents?.some(
                (doc) =>
                  doc?.name ===
                  selectedRow?.selected_documents?.[leftValue]?.name
              )) ||
            // Case 3: leftValue >= 1 and pp_notarized is true
            (leftValue >= 1 &&
              selectedRow?.pp_notarized === true &&
              isMainPermitType) ? (
              <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
            ) : (
              // Default case: red cancel icon
              <CancelIcon color="error" sx={{ fontSize: 30 }} />
            )
          }
          <Typography variant="caption" color="textSecondary" fontWeight="bold">
            Notarized
          </Typography>
        </Box>
      </Tooltip>
      {/* Recorded Status */}
      {selectedRow?.selected_documents?.[leftValue]?.name === "noc" &&
        isMainPermitType && (
          <Tooltip title="Document Recorded">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {selectedRow?.recorded ? (
                <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
              ) : (
                <CancelIcon color="error" sx={{ fontSize: 30 }} />
              )}
              <Typography
                variant="caption"
                color="textSecondary"
                fontWeight="bold"
              >
                Recorded
              </Typography>
            </Box>
          </Tooltip>
        )}
      {/* Downloaded Status */}
      <Tooltip title="Document Downloaded">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {currentPermitData?.documents?.[
            currentPermitData?.selected_documents?.[leftValue]?.name
          ]?.download_info?.downloaded === true ? (
            <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
          ) : (
            <CancelIcon color="error" sx={{ fontSize: 30 }} />
          )}
          <Typography variant="caption" color="textSecondary" fontWeight="bold">
            Downloaded
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default React.memo(PermitPackageIndicators);
